import { useMemo } from "react";

// Хук для форматування назви товару
const useFormattedName = (name: string) => {
  return useMemo(() => {
    // 1. Видаляємо зайві пробіли на початку та в кінці
    let formattedName = name.trim();

    // 2. Заміняємо всі символи / на дефіси, а також довгі тире (—) на звичайні дефіси
    formattedName = formattedName
      .replace(/[\/]/g, "-") // Заміняємо всі / на дефіси
      .replace(/[–—]/g, "-") // Заміняємо довгі тире (– або —) на дефіси
      .replace(/\s+/g, "-") // Заміняємо пробіли на дефіси
      .replace(/[^a-zA-Z0-9-]/g, "") // Видаляємо усі символи, які не є літерами, цифрами або дефісами
      .toLowerCase(); // Перетворюємо все на маленькі літери

    // 3. Прибираємо зайві дефіси: два або більше підряд
    formattedName = formattedName.replace(/-+/g, "-");

    return formattedName;
  }, [name]);
};

export default useFormattedName;
